import permission from './permission.js'
import login from './login'
export default {
  permission,
  login
}
